import { Study } from '@models';

function compare(a: number | string, b: number | string, isAsc: boolean): number {
  if (a == null && b == null) return 0;
  if (a == null) return isAsc ? -1 : 1;
  if (b == null) return isAsc ? 1 : -1;

  if (typeof a === 'string' && typeof b === 'string' && a.includes(' of ') && b.includes(' of ')) {
    const numA = parseInt(a.split(' of ')[0], 10);
    const numB = parseInt(b.split(' of ')[0], 10);

    if (!isNaN(numA) && !isNaN(numB)) {
      return (numA < numB ? -1 : 1) * (isAsc ? 1 : -1);
    }
  }

  if (typeof a === 'string' && typeof b === 'string') {
    return a.localeCompare(b) * (isAsc ? 1 : -1);
  }

  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}

function sortByCustomOrder<K extends keyof Study>(
  items: Study[],
  field: K,
  customOrder: string[]
): Study[] {
  const orderMap = new Map<string, number>();
  customOrder.forEach((item, idx) => {
    orderMap.set(item.toLowerCase(), idx);
  });
  return [...items].sort((a, b) => {
    const valueA = String(a[field]).trim();
    const valueB = String(b[field]).trim();

    const indexA = orderMap.get(valueA.toLowerCase());
    const indexB = orderMap.get(valueB.toLowerCase());
    if (indexA === undefined && indexB === undefined) {
      return 0;
    }
    if (indexA === undefined) {
      return 1;
    }
    if (indexB === undefined) {
      return -1;
    }
    return indexA - indexB;
  });
}

function sortStandard<K extends keyof Study>(
  items: Study[],
  field: K,
  ascending: boolean
): Study[] {
  return [...items].sort((a, b) => {
    const valueA = a[field];
    const valueB = b[field];

    if (valueA === null || valueA === undefined) return ascending ? -1 : 1;
    if (valueB === null || valueB === undefined) return ascending ? 1 : -1;

    if (valueA < valueB) return ascending ? -1 : 1;
    if (valueA > valueB) return ascending ? 1 : -1;
    return 0;
  });
}

export { compare, sortByCustomOrder, sortStandard };
